import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iframeValidator',
  standalone: true
})
export class IframeValidatorPipe implements PipeTransform {

  transform(html: string): boolean {
    if (!html) {
      return false
/*      return {
        isValid:false,
        value:'Пустой HTML'
      };*/
    }

    // Создаем DOM-парсер
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const iframe = doc.querySelector('iframe');
    if (!iframe) {
      return false
/*      return {
        isValid:false,
        value:'Iframe не найден'
      };*/
    }

    // Проверка на синтаксические ошибки
    const parseErrors = doc.querySelectorAll('parsererror');
    if (parseErrors.length > 0) {
      return  false;
      /*return {
        isValid:false,
        value:'Синтаксическая ошибка в HTML'
      };*/

    }

    // Проверка атрибутов
    if (!iframe.hasAttribute('src')) {
      return  false;
/*      return {
        isValid:false,
        value:'Iframe должен содержать атрибут src'
      };*/
    }
    return  true;
/*    return {
      isValid:true,
      value:html
    };*/
  }

}
